import { ExternalUrlItem, ExternalUrlValue } from 'app/area/external-url-groups/form/types-store';
import { ComplexValue } from 'app/types-shared';

export const createDefaultExternalUrl = (externalUrlValue: ExternalUrlValue, sequence: number): ExternalUrlItem => ({
  code: {
    value: externalUrlValue.value,
    description: externalUrlValue.description,
    longDescription: externalUrlValue?.longDescription
  },
  sequence,
  disabled: undefined,
  urlTemplate: externalUrlValue.urlTemplate
});

export const createExternalUrlSelectedValues = (externalUrls: ExternalUrlItem[] = []): ComplexValue<number>[] =>
  externalUrls.map(url => ({
    value: url.code.value,
    description: url.code.description,
    longDescription: url.code?.longDescription
  }));
